import React from "react";

import "./style.scss";

import { get, set } from "lodash";

import MDCTextField from "@material-ui/core/TextField";
import MDCInput from "@material-ui/core/Input";
import MDCSwitch from "@material-ui/core/Switch";
import MDCSlider from "@material-ui/core/Slider";

import MDCRadio from "@material-ui/core/Radio";
import MDCRadioGroup from "@material-ui/core/RadioGroup";
import MDCNativeSelect from "@material-ui/core/NativeSelect";

import MDCFormGroup from "@material-ui/core/FormGroup";
import MDCCheckbox from "@material-ui/core/Checkbox";

import MDCFormControlLabel from "@material-ui/core/FormControlLabel";
import MDCFormLabel from "@material-ui/core/FormLabel";

import MDCFormControl from "@material-ui/core/FormControl";
import MDCFormHelperText from "@material-ui/core/FormHelperText";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";

class Textbox extends React.Component {
  render() {
    const { input, value, onSetValue } = this.props;

    return (
      <MDCInput
        fullWidth
        value={value}
        onChange={(e) => onSetValue(input.value, e.target.value)}
      />
    );
  }
}

class Textarea extends React.Component {
  render() {
    const { input, value, onSetValue } = this.props;

    return (
      <MDCInput
        fullWidth
        value={value}
        onChange={(e) => onSetValue(input.value, e.target.value)}
      />
    );
  }
}

class TextboxDate extends React.Component {
  onSetValue(value) {
    const { input, onSetValue } = this.props;

    const date = new Date(value);
    const timestamp = Math.round(date.getTime() / 1000);

    return onSetValue(input.value, timestamp);
  }

  onGetValue() {
    const { value } = this.props;

    const timestamp = value * 1000;
    const date = new Date(timestamp);

    return date.toISOString().slice(0, 10);
  }

  render() {
    const value = this.onGetValue();

    return (
      <MDCInput
        fullWidth
        type="date"
        value={value}
        onChange={(e) => this.onSetValue(e.target.value)}
      />
    );
  }
}

class TextboxTime extends React.Component {
  render() {
    const { input, value, onSetValue } = this.props;

    return (
      <MDCInput
        fullWidth
        type="time"
        value={value}
        onChange={(e) => onSetValue(input.value, e.target.value)}
      />
    );
  }
}

class TextboxDateTime extends React.Component {
  onSetValue(value) {
    const { input, onSetValue } = this.props;

    const date = new Date(value);
    const timestamp = Math.round(date.getTime() / 1000);

    return onSetValue(input.value, timestamp);
  }

  onGetValue() {
    const { value } = this.props;

    const timestamp = value * 1000;
    const date = new Date(timestamp);

    return date.toISOString().slice(0, 19);
  }

  render() {
    const value = this.onGetValue();

    return (
      <MDCInput
        fullWidth
        type="datetime-local"
        value={value}
        onChange={(e) => this.onSetValue(e.target.value)}
      />
    );
  }
}

class CheckboxGroup extends React.Component {
  onSetValue(id) {
    const { input, onSetValue } = this.props;
    let { value } = this.props;

    if (!value) {
      value = [];
    }

    if (value.includes(id)) {
      return onSetValue(
        input.value,
        value.reduce((agg, item) => (item === id ? agg : [...agg, item]), [])
      );
    }

    return onSetValue(input.value, [...value, id]);
  }

  render() {
    const { input } = this.props;
    let { value } = this.props;

    const items = input.items ? input.items : [];

    if (!value) {
      value = [];
    }

    return (
      <MDCFormGroup fullWidth>
        {items.map((item) => (
          <Checkbox
            key={item.id}
            item={item}
            selected={value.includes(item.id)}
            onSetValue={(id) => this.onSetValue(id)}
          />
        ))}
      </MDCFormGroup>
    );
  }
}

class RadioGroup extends React.Component {
  onSetValue(id) {
    const { input, onSetValue } = this.props;
    return onSetValue(input.value, id);
  }

  render() {
    const { input, value } = this.props;

    const items = input.items ? input.items : [];

    return (
      <MDCRadioGroup fullWidth>
        {items.map((item) => (
          <Radio
            key={item.id}
            item={item}
            selected={value === item.id}
            onSetValue={(id) => this.onSetValue(id)}
          />
        ))}
      </MDCRadioGroup>
    );
  }
}

class Checkbox extends React.Component {
  render() {
    const { item, onSetValue, selected } = this.props;

    return (
      <MDCFormControlLabel
        fullWidth
        control={
          <MDCCheckbox
            fullWidth
            value={item.id}
            onChange={() => onSetValue(item.id)}
            checked={selected}
          />
        }
        label={item.name}
      />
    );
  }
}

class Radio extends React.Component {
  render() {
    const { item, onSetValue, selected } = this.props;

    return (
      <MDCFormControlLabel
        control={
          <MDCRadio
            fullWidth
            value={item.id}
            onChange={() => onSetValue(item.id)}
            checked={selected}
          />
        }
        label={item.name}
      />
    );
  }
}

class Select extends React.Component {
  render() {
    const { input, value, onSetValue } = this.props;

    const items = input.items ? input.items : [];

    return (
      <MDCNativeSelect
        fullWidth
        onChange={(e) => onSetValue(input.value, parseInt(e.target.value))}
      >
        {items.map((item) => (
          <SelectOption item={item} selected={value === item.id} />
        ))}
      </MDCNativeSelect>
    );
  }
}

class SelectOption extends React.Component {
  render() {
    const { item, selected } = this.props;

    return (
      <option value={item.id} selected={selected}>
        {item.name}
      </option>
    );
  }
}

class Slider extends React.Component {
  render() {
    const { input, value, onSetValue } = this.props;

    const { min, max } = input;

    return (
      <MDCSlider
        fullWidth
        defaultValue={value}
        min={min}
        max={max}
        onChange={(e, value) => onSetValue(input.value, value)}
      />
    );
  }
}

class Switch extends React.Component {
  render() {
    const { input, onSetValue } = this.props;
    let { value } = this.props;

    value = Boolean(Number(value));

    return (
      <MDCSwitch
        fullWidth
        checked={value}
        onChange={(e) => onSetValue(input.value, e.target.checked ? 1 : 0)}
      />
    );
  }
}

const inputMap = {
  Textbox: Textbox,
  Date: TextboxDate,
  Time: TextboxTime,
  DateTime: TextboxDateTime,
  Textarea: Textarea,
  Checkbox: CheckboxGroup,
  Radio: RadioGroup,
  Select: Select,
  Slider: Slider,
  Switch: Switch,
};

class Input extends React.Component {
  render() {
    const { input, data } = this.props;

    if (!input) {
      return "x";
    }

    const value = get(data, input.value, null);

    const Component = inputMap[input.type];

    return (
      <div className="input">
        <MDCFormControl margin="dense" fullWidth>
          <MDCFormLabel>{input.name}</MDCFormLabel>
          <div className="component">
            <Component
              input={input}
              value={value}
              onSetValue={this.props.onSetValue}
            />
          </div>
          {input.helperText && (
            <MDCFormHelperText>{input.helperText}</MDCFormHelperText>
          )}
        </MDCFormControl>
      </div>
    );
  }
}

class Inputs extends React.Component {
  render() {
    const { inputs, data } = this.props;

    return (
      <div className="inputs">
        {inputs.map((input) => (
          <Input input={input} data={data} onSetValue={this.props.onSetValue} />
        ))}
      </div>
    );
  }
}

class Page extends React.Component {
  render() {
    const { page, data } = this.props;

    if (!page) {
      return null;
    }

    const inputs = page.inputs || [];
    const isVisible = this.props.isVisible;

    if (!isVisible) {
      return null;
    }

    return (
      <div className="page">
        <Inputs
          inputs={inputs}
          data={data}
          onSetValue={this.props.onSetValue}
        />
      </div>
    );
  }
}

class Pages extends React.Component {
  render() {
    const { currentPageId, pages, data, onSetValue } = this.props;

    return (
      <div className="pages">
        {pages.map((page, index) => (
          <Page
            page={page}
            data={data}
            onSetValue={onSetValue}
            isVisible={currentPageId === index}
          />
        ))}
      </div>
    );
  }
}

class PageStepper extends React.Component {
  render() {
    const { currentPageId, pages } = this.props;

    return (
      <Stepper activeStep={currentPageId} alternativeLabel>
        {pages.map((page) => (
          <Step key={page.id}>
            <StepLabel>{page.name}</StepLabel>
          </Step>
        ))}
      </Stepper>
    );
  }
}

class PageNavigation extends React.Component {
  render() {
    const { currentPageId, pages, onNextPage, onPrevPage } = this.props;

    const total = pages.length;

    return (
      <div className="page-navigation">
        {
          <div>
            <Button disabled={currentPageId === 0} onClick={onPrevPage}>
              Back
            </Button>
            <Button variant="contained" color="primary" onClick={onNextPage}>
              {currentPageId === total - 1 ? "Finish" : "Next"}
            </Button>
          </div>
        }
      </div>
    );
  }
}

export default class extends React.Component {
  state = {
    currentPageId: 0,
    data: this.props.data,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
      });
    }
  }

  render() {
    const { currentPageId, data } = this.state;

    const { form, hasStepper, hasNavigation } = this.props;

    const { pages } = form;

    if (!pages) {
      return null;
    }

    return (
      <div className="zee-form">
        {hasStepper && (
          <PageStepper pages={pages} currentPageId={currentPageId} />
        )}
        <Pages
          currentPageId={currentPageId}
          pages={pages}
          data={data}
          onSetValue={(index, value) => this.setValue(index, value)}
        />
        {hasNavigation && (
          <PageNavigation
            pages={pages}
            currentPageId={currentPageId}
            onNextPage={() => this.onNextPage()}
            onPrevPage={() => this.onPrevPage()}
          />
        )}
      </div>
    );
  }

  setValue(index, value) {
    const { data } = this.state;
    set(data, index, value);
    this.setState({
      data,
    });

    const onUpdate = this.props.onUpdate || null;
    if (onUpdate) {
      onUpdate(data);
    }
  }

  onPrevPage() {
    let { currentPageId } = this.state;

    if (currentPageId === 0) {
      return;
    }

    currentPageId = currentPageId - 1;

    this.setState({
      currentPageId,
    });
  }

  onNextPage() {
    let { currentPageId } = this.state;

    const { form } = this.props;
    const { pages } = form;

    if (currentPageId === pages.length - 1) {
      return;
    }

    currentPageId = currentPageId + 1;

    this.setState({
      currentPageId,
    });
  }
}
